import { useState } from 'react'

import Modal from 'tools/Modal'
import { Icon } from 'tools/Uniform/Icons'
import { stopEvent } from 'utils/event'

export function TrashButton({
  disabled,
  onClick,
  className = 'clear f1 ph2 pv1 flex-items gh2',
  children
}) {
  return (
    <button className={className} disabled={disabled} onClick={onClick}>
      <Icon type="trash" />
      {children}
    </button>
  )
}

export function Delete({ className = '', onConfirm, children }) {
  const [drop, setDrop] = useState(false)
  return (
    <>
      <TrashButton
        className={className}
        onClick={(ev) => {
          stopEvent(ev)
          setDrop(!drop)
        }}
      />
      {drop && (
        <div onClick={(e) => stopEvent(e)}>
          <ConfirmPassState
            viewState={[drop, setDrop]}
            onConfirm={() => {
              onConfirm()
              setDrop(false)
            }}
          >
            {children}
          </ConfirmPassState>
        </div>
      )}
    </>
  )
}

export function ClosableModal({
  children = undefined,
  title = '',
  closeText = 'Close',
  viewState
}) {
  const [, setOpen] = viewState
  return (
    <Modal
      viewState={viewState}
      width="fw-50"
      noScroll={true}
      className="base-frame pa4"
    >
      <div className="f5 b">{title}</div>
      <div className="mt3">{children}</div>
      <div className="mt3 flex justify-end">
        <button className="large" onClick={() => setOpen(false)}>
          {closeText}
        </button>
      </div>
    </Modal>
  )
}

export function ConfirmPassState({
  onConfirm,
  children = undefined,
  title = '',
  viewState
}) {
  const [, setOpen] = viewState
  return (
    <Modal
      viewState={viewState}
      width="fw-50"
      noScroll={true}
      className="base-frame pa4"
    >
      <div className="f5 b">{title || 'Are you sure?'}</div>
      <div className="mt3">{children}</div>
      <div className="mt3 flex justify-between">
        <button className="large border" onClick={() => setOpen(false)}>
          No
        </button>
        <button
          className="large"
          onClick={() => {
            onConfirm()
            setOpen(false)
          }}
        >
          Yes
        </button>
      </div>
    </Modal>
  )
}

export function Confirm({ label, onConfirm, hoverHide = true, ...props }) {
  const [open, setOpen] = useState(false)
  return (
    <>
      <TrashButton
        onClick={(e) => {
          stopEvent(e)
          setOpen(true)
        }}
      >
        {label}
      </TrashButton>
      {open ? (
        <ConfirmPassState
          {...props}
          onConfirm={onConfirm}
          viewState={[open, setOpen]}
        />
      ) : null}
    </>
  )
}

export default Confirm
